<h2 mat-dialog-title class="flex items-center gap-2">
    <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-warn"></mat-icon>
    Limite atingido
</h2>

<mat-dialog-content>
    <p class="text-secondary mb-4">
        Você atingiu o limite de uso para <strong>{{ data.feature }}</strong>.
    </p>

    <div class="flex items-center justify-between text-sm mb-1">
        <span class="text-secondary">Uso</span>
        <span class="font-semibold">{{ data.used }} / {{ data.limit }}</span>
    </div>
    <mat-progress-bar mode="determinate" [value]="100" color="warn"></mat-progress-bar>

    <p class="text-sm text-secondary mt-4" *ngIf="data.resetsAt">
        O limite será renovado em <strong>{{ data.resetsAt | date:'dd/MM/yyyy' }}</strong>.
    </p>
    <p class="text-sm text-secondary mt-2">
        Faça upgrade do seu plano para aumentar seus limites.
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Fechar</button>
    <button mat-flat-button color="primary" (click)="goToUpgrade()">
        Fazer upgrade
    </button>
</mat-dialog-actions>
